import React from "react";

import { useGlobalContext } from "./context/globalContext";

const Hero = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <div id="home" className="section">
      <div className="desktopview">
        <img
          onClick={() => handleShowModal("Web Banner")}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/web-banner-a1.png"
          alt="L&T Wagle Estate"
        />
      </div>
      <div className="mobileview">
        <img
          onClick={() => handleShowModal("Mob Banner")}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/mobile-banner-a1.png"
          alt="L&T Wagle Estate"
        />
      </div>
    </div>
  );
};

export default Hero;
